import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { UserCreatePayload } from '../models/user-create-model';

@Injectable({
  providedIn: 'root',
})
export class ConfigMasterService {
  constructor(private http: HttpClient) {}

  lFN_GetUserRoles(): Observable<{ message: string; data: any[] }> {
    return this.http.get<{ message: string; data: any[] }>(
      `${environment.ROOT_URL}/config-master/roles`
    );
  }

  

  // lFN_GetBookById(bookId: number) {
  //     return this.http.get(`${environment.ROOT_URL}/jsyoglibrary/bookDetail/bookId/` + bookId, { withCredentials: false, responseType: 'text', observe: 'response' });
  // }

  // lFN_UpdateBookById(bookId: number, bookData: Book) {
  //     return this.http.put(`${environment.ROOT_URL}/jsyoglibrary/book/bookId/` + bookId, bookData, { withCredentials: false, responseType: 'text', observe: 'response' });
  // }
}
